import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CreNgConfig } from 'cre-ng';

/**
 * Base class for api services. Supports environment configuration.
 */
@Injectable()
export abstract class BaseService {
  /** @ignore */
  protected config: CreNgConfig;
  /** @ignore */
  protected httpClient: HttpClient;
  /** @ignore */
  protected get serviceUrl(): string {
    const result = this.config.serviceApiDomain + this.getEndPoint();

    return result;
  }

  /** @ignore */
  constructor(config: CreNgConfig, httpClient: HttpClient) {
    this.config = config;
    this.httpClient = httpClient;
  }

  /**
   * Must implement. Return the base end point path of the service.
   * e.g. '/company/api/v1' for the CompanyService.
   */
  protected abstract getEndPoint(): string;

  /**
   * Gets HttpHeaders
   *
   * @param token JWT token.
   */
  getHttpHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.getToken()}`,
    });

    return headers;
  }

  /** @ignore */
  protected getToken() {
    return localStorage.getItem('cre_undefined_auth')
      ? localStorage.getItem('cre_undefined_auth')
      : null;
  }
}
